import { useContext } from 'react';
import { NotificacaoContext } from '../contexts/NotificacaoContext';

const useNotificacoes = () => {
  const context = useContext(NotificacaoContext);
  if (!context) {
    throw new Error('useNotificacoes deve ser usado dentro de um NotificacaoProvider');
  }
  return context;
};

export default useNotificacoes;